import { combineReducers } from 'redux';
import { reducer as wpPosts } from './postsModule';

export default combineReducers({
	wpPosts,
});
